export default "__VITE_ASSET__p0lmAR2G__"